import React, { useState } from 'react';

const ProposedStructureSection = ({ structure, navigation }) => {
    const [expandedGroups, setExpandedGroups] = useState({});
    const [expandedNav, setExpandedNav] = useState({ primary: true, secondary_new: true, footer: true });

    const hasNewNavigation = navigation && (
        (navigation.primary_navigation && navigation.primary_navigation.items && navigation.primary_navigation.items.length > 0) ||
        (navigation.secondary_navigation && navigation.secondary_navigation.items && navigation.secondary_navigation.items.length > 0) ||
        (navigation.footer_navigation && navigation.footer_navigation.items && navigation.footer_navigation.items.length > 0)
    );

    if (!structure && !navigation && !hasNewNavigation) {
        return (
            <div style={{ marginBottom: '30px' }}>
                <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>Proposed Structure</h4>
                <div style={{
                    background: 'linear-gradient(135deg, rgba(156, 163, 175, 0.18), rgba(156, 163, 175, 0.06))',
                    border: '1px solid rgba(156, 163, 175, 0.35)',
                    borderRadius: '12px',
                    padding: '20px',
                    color: '#a0a0a0',
                    textAlign: 'center'
                }}>
                    No proposed structure data available
                </div>
            </div>
        );
    }

    const toggleGroup = (groupId) => {
        setExpandedGroups(prev => ({
            ...prev,
            [groupId]: !prev[groupId]
        }));
    };

    const toggleNav = (navType) => {
        setExpandedNav(prev => ({
            ...prev,
            [navType]: !prev[navType]
        }));
    };

    const cardStyle = {
        background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.18), rgba(59, 130, 246, 0.05))',
        border: '1px solid rgba(59, 130, 246, 0.35)',
        borderRadius: '12px',
        padding: '20px',
        marginBottom: '20px'
    };

    const headingStyle = {
        fontSize: '18px',
        fontWeight: '600',
        color: '#e0e0e0',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        userSelect: 'none'
    };

    const subHeadingStyle = {
        fontSize: '14px',
        fontWeight: '600',
        color: '#c0c0c0',
        marginTop: '16px',
        marginBottom: '10px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    };

    const itemStyle = {
        backgroundColor: '#2d2d2d',
        border: '1px solid #404040',
        borderRadius: '8px',
        padding: '12px',
        marginBottom: '10px'
    };

    const labelStyle = {
        fontSize: '12px',
        color: '#9a9a9a',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: '6px',
        fontWeight: '600'
    };

    const valueStyle = {
        fontSize: '14px',
        color: '#e0e0e0',
        wordBreak: 'break-word'
    };

    const linkStyle = {
        color: '#60a5fa',
        textDecoration: 'none'
    };

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '20px', color: '#e0e0e0', fontWeight: '600' }}>Proposed Structure</h4>
            
            {/* Semantic Groups (Structure) */}
            {structure && structure.semantic_groups && structure.semantic_groups.length > 0 && (
                <div style={cardStyle}>
                    <h5 
                        style={headingStyle}
                        onClick={() => toggleGroup('semantic_groups')}
                    >
                        Semantic Groups
                        <span style={{ fontSize: '12px', color: '#9a9a9a' }}>
                            {expandedGroups.semantic_groups ? '▼' : '▶'}
                        </span>
                    </h5>
                    {expandedGroups.semantic_groups !== false && (
                        <div>
                            {structure.semantic_groups.map((group, index) => (
                                <div key={index} style={itemStyle}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
                                        <h6 style={{ fontSize: '16px', fontWeight: '600', color: '#ffffff', margin: 0 }}>
                                            {group.name}
                                        </h6>
                                        <span style={{
                                            backgroundColor: '#3b82f6',
                                            color: '#ffffff',
                                            padding: '4px 10px',
                                            borderRadius: '12px',
                                            fontSize: '12px',
                                            fontWeight: '600'
                                        }}>
                                            {group.pages.length} {group.pages.length === 1 ? 'page' : 'pages'}
                                        </span>
                                    </div>
                                    
                                    {group.description && (
                                        <div style={{ marginBottom: '10px' }}>
                                            <div style={labelStyle}>Description</div>
                                            <div style={valueStyle}>{group.description}</div>
                                        </div>
                                    )}
                                    
                                    {group.reasoning && (
                                        <div style={{ marginBottom: '10px' }}>
                                            <div style={labelStyle}>Reasoning</div>
                                            <div style={valueStyle}>{group.reasoning}</div>
                                        </div>
                                    )}
                                    
                                    {group.pages && group.pages.length > 0 && (
                                        <div>
                                            <div style={labelStyle}>Pages</div>
                                            <ul style={{ margin: 0, paddingLeft: '20px', color: '#e0e0e0' }}>
                                                {group.pages.map((pageUrl, pageIndex) => (
                                                    <li key={pageIndex} style={{ marginBottom: '6px' }}>
                                                        <a 
                                                            href={pageUrl} 
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                            style={linkStyle}
                                                        >
                                                            {pageUrl}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {/* Graph Nodes and Edges */}
            {structure && structure.graph && (
                <div style={cardStyle}>
                    <h5 
                        style={headingStyle}
                        onClick={() => toggleGroup('graph')}
                    >
                        Structure Graph
                        <span style={{ fontSize: '12px', color: '#9a9a9a' }}>
                            {expandedGroups.graph ? '▼' : '▶'}
                        </span>
                    </h5>
                    {expandedGroups.graph !== false && (
                        <div>
                            {structure.graph.nodes && structure.graph.nodes.length > 0 && (
                                <div style={{ marginBottom: '16px' }}>
                                    <div style={subHeadingStyle}>Nodes ({structure.graph.nodes.length})</div>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px' }}>
                                        {structure.graph.nodes.map((node, index) => (
                                            <div key={index} style={{
                                                backgroundColor: '#2d2d2d',
                                                border: '1px solid #404040',
                                                borderRadius: '6px',
                                                padding: '10px',
                                                textAlign: 'center'
                                            }}>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#ffffff', marginBottom: '4px' }}>
                                                    {node.name}
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#9a9a9a' }}>
                                                    {node.page_count} {node.page_count === 1 ? 'page' : 'pages'}
                                                </div>
                                                <div style={{ fontSize: '10px', color: '#6a6a6a', marginTop: '4px' }}>
                                                    {node.id}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                            
                            {structure.graph.edges && structure.graph.edges.length > 0 && (
                                <div>
                                    <div style={subHeadingStyle}>Connections ({structure.graph.edges.length})</div>
                                    <div style={{
                                        backgroundColor: '#2d2d2d',
                                        border: '1px solid #404040',
                                        borderRadius: '8px',
                                        padding: '12px',
                                        maxHeight: '300px',
                                        overflowY: 'auto'
                                    }}>
                                        {structure.graph.edges.map((edge, index) => {
                                            const sourceNode = structure.graph.nodes?.find(n => n.id === edge.source);
                                            const targetNode = structure.graph.nodes?.find(n => n.id === edge.target);
                                            return (
                                                <div key={index} style={{
                                                    padding: '8px',
                                                    marginBottom: '6px',
                                                    backgroundColor: '#1f1f1f',
                                                    borderRadius: '4px',
                                                    fontSize: '13px',
                                                    color: '#c0c0c0'
                                                }}>
                                                    <span style={{ color: '#60a5fa', fontWeight: '600' }}>
                                                        {sourceNode?.name || edge.source}
                                                    </span>
                                                    <span style={{ margin: '0 8px', color: '#6a6a6a' }}>→</span>
                                                    <span style={{ color: '#60a5fa', fontWeight: '600' }}>
                                                        {targetNode?.name || edge.target}
                                                    </span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}

            {/* Navigation (Pages with nav info) */}
            {navigation && navigation.pages && navigation.pages.length > 0 && (
                <div style={cardStyle}>
                    <h5 
                        style={headingStyle}
                        onClick={() => toggleGroup('navigation')}
                    >
                        Navigation Pages ({navigation.pages.length})
                        <span style={{ fontSize: '12px', color: '#9a9a9a' }}>
                            {expandedGroups.navigation ? '▼' : '▶'}
                        </span>
                    </h5>
                    {expandedGroups.navigation !== false && (
                        <div style={{
                            backgroundColor: '#2d2d2d',
                            border: '1px solid #404040',
                            borderRadius: '8px',
                            padding: '12px',
                            maxHeight: '400px',
                            overflowY: 'auto'
                        }}>
                            {navigation.pages.map((page, index) => (
                                <div key={index} style={{
                                    padding: '12px',
                                    marginBottom: '8px',
                                    backgroundColor: '#1f1f1f',
                                    borderRadius: '6px',
                                    border: '1px solid #333333'
                                }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                                        <a 
                                            href={page.url} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            style={{ ...linkStyle, fontSize: '14px', fontWeight: '600', wordBreak: 'break-word' }}
                                        >
                                            {page.url}
                                        </a>
                                        {page.nav_item_label && (
                                            <span style={{
                                                backgroundColor: '#10b981',
                                                color: '#ffffff',
                                                padding: '4px 10px',
                                                borderRadius: '12px',
                                                fontSize: '11px',
                                                fontWeight: '600',
                                                marginLeft: '10px',
                                                whiteSpace: 'nowrap'
                                            }}>
                                                {page.nav_item_label}
                                            </span>
                                        )}
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', fontSize: '12px' }}>
                                        {page.group_name && (
                                            <span style={{ color: '#9a9a9a' }}>
                                                Group: <span style={{ color: '#e0e0e0', fontWeight: '600' }}>{page.group_name}</span>
                                            </span>
                                        )}
                                        {page.nav_level && (
                                            <span style={{ color: '#9a9a9a' }}>
                                                Level: <span style={{ color: '#e0e0e0', fontWeight: '600' }}>{page.nav_level}</span>
                                            </span>
                                        )}
                                        {page.page_hash && (
                                            <span style={{ color: '#6a6a6a', fontFamily: 'monospace', fontSize: '10px' }}>
                                                {page.page_hash.substring(0, 12)}...
                                            </span>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {/* New Navigation Structure (Primary, Secondary, Footer) */}
            {hasNewNavigation && (
                <div style={cardStyle}>
                    <h5 style={{ fontSize: '16px', fontWeight: '600', color: '#e0e0e0', marginBottom: '16px' }}>
                        Proposed Website Navigation
                    </h5>

                    {/* Reasoning */}
                    {navigation.reasoning && (
                        <div style={{
                            backgroundColor: '#2d2d2d',
                            border: '1px solid #404040',
                            borderRadius: '8px',
                            padding: '16px',
                            marginBottom: '20px'
                        }}>
                            <div style={labelStyle}>Reasoning</div>
                            <div style={{ ...valueStyle, lineHeight: '1.6', fontSize: '13px' }}>
                                {navigation.reasoning}
                            </div>
                        </div>
                    )}

                    {/* Primary Navigation */}
                    {navigation.primary_navigation && navigation.primary_navigation.items && navigation.primary_navigation.items.length > 0 && (
                        <div style={{ marginBottom: '20px' }}>
                            <h6 
                                style={{
                                    ...subHeadingStyle,
                                    cursor: 'pointer',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}
                                onClick={() => toggleNav('primary')}
                            >
                                Primary Navigation ({navigation.primary_navigation.items.length})
                                <span style={{ fontSize: '12px', color: '#9a9a9a' }}>
                                    {expandedNav.primary !== false ? '▼' : '▶'}
                                </span>
                            </h6>
                            {expandedNav.primary !== false && (
                                <div>
                                    {navigation.primary_navigation.items.map((item, index) => (
                                        <div key={index} style={{
                                            backgroundColor: '#2d2d2d',
                                            border: '1px solid #404040',
                                            borderRadius: '8px',
                                            padding: '12px',
                                            marginBottom: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '12px'
                                        }}>
                                            <span style={{
                                                backgroundColor: '#3b82f6',
                                                color: '#ffffff',
                                                padding: '4px 10px',
                                                borderRadius: '6px',
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                minWidth: '60px',
                                                textAlign: 'center'
                                            }}>
                                                {index + 1}
                                            </span>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#ffffff', marginBottom: '4px' }}>
                                                    {item.label}
                                                </div>
                                                {item.group_name && (
                                                    <div style={{ fontSize: '12px', color: '#9a9a9a', marginBottom: '4px' }}>
                                                        Group: <span style={{ color: '#e0e0e0' }}>{item.group_name}</span>
                                                    </div>
                                                )}
                                                {item.url && (
                                                    <a 
                                                        href={item.url} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        style={{ ...linkStyle, fontSize: '12px', wordBreak: 'break-word' }}
                                                    >
                                                        {item.url}
                                                    </a>
                                                )}
                                                {!item.url && (
                                                    <span style={{ fontSize: '12px', color: '#9a9a9a', fontStyle: 'italic' }}>
                                                        No URL (utility action)
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}

                    {/* Secondary Navigation */}
                    {navigation.secondary_navigation && navigation.secondary_navigation.items && navigation.secondary_navigation.items.length > 0 && (
                        <div style={{ marginBottom: '20px' }}>
                            <h6 
                                style={{
                                    ...subHeadingStyle,
                                    cursor: 'pointer',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}
                                onClick={() => toggleNav('secondary_new')}
                            >
                                Secondary Navigation ({navigation.secondary_navigation.items.length})
                                <span style={{ fontSize: '12px', color: '#9a9a9a' }}>
                                    {expandedNav.secondary_new !== false ? '▼' : '▶'}
                                </span>
                            </h6>
                            {expandedNav.secondary_new !== false && (
                                <div>
                                    {navigation.secondary_navigation.items.map((item, index) => (
                                        <div key={index} style={{
                                            backgroundColor: '#2d2d2d',
                                            border: '1px solid #404040',
                                            borderRadius: '8px',
                                            padding: '12px',
                                            marginBottom: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '12px'
                                        }}>
                                            <span style={{
                                                backgroundColor: '#10b981',
                                                color: '#ffffff',
                                                padding: '4px 10px',
                                                borderRadius: '6px',
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                minWidth: '60px',
                                                textAlign: 'center'
                                            }}>
                                                {index + 1}
                                            </span>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#ffffff', marginBottom: '4px' }}>
                                                    {item.label}
                                                </div>
                                                {item.group_name && (
                                                    <div style={{ fontSize: '12px', color: '#9a9a9a', marginBottom: '4px' }}>
                                                        Group: <span style={{ color: '#e0e0e0' }}>{item.group_name}</span>
                                                    </div>
                                                )}
                                                {item.url && (
                                                    <a 
                                                        href={item.url} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        style={{ ...linkStyle, fontSize: '12px', wordBreak: 'break-word' }}
                                                    >
                                                        {item.url}
                                                    </a>
                                                )}
                                                {!item.url && (
                                                    <span style={{ fontSize: '12px', color: '#9a9a9a', fontStyle: 'italic' }}>
                                                        No URL (utility action)
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}

                    {/* Footer Navigation */}
                    {navigation.footer_navigation && navigation.footer_navigation.items && navigation.footer_navigation.items.length > 0 && (
                        <div>
                            <h6 
                                style={{
                                    ...subHeadingStyle,
                                    cursor: 'pointer',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}
                                onClick={() => toggleNav('footer')}
                            >
                                Footer Navigation ({navigation.footer_navigation.items.length})
                                <span style={{ fontSize: '12px', color: '#9a9a9a' }}>
                                    {expandedNav.footer !== false ? '▼' : '▶'}
                                </span>
                            </h6>
                            {expandedNav.footer !== false && (
                                <div>
                                    {navigation.footer_navigation.items.map((item, index) => (
                                        <div key={index} style={{
                                            backgroundColor: '#2d2d2d',
                                            border: '1px solid #404040',
                                            borderRadius: '8px',
                                            padding: '12px',
                                            marginBottom: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '12px'
                                        }}>
                                            <span style={{
                                                backgroundColor: '#8b5cf6',
                                                color: '#ffffff',
                                                padding: '4px 10px',
                                                borderRadius: '6px',
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                minWidth: '60px',
                                                textAlign: 'center'
                                            }}>
                                                {index + 1}
                                            </span>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#ffffff', marginBottom: '4px' }}>
                                                    {item.label}
                                                </div>
                                                {item.group_name && (
                                                    <div style={{ fontSize: '12px', color: '#9a9a9a', marginBottom: '4px' }}>
                                                        Group: <span style={{ color: '#e0e0e0' }}>{item.group_name}</span>
                                                    </div>
                                                )}
                                                {item.url && (
                                                    <a 
                                                        href={item.url} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        style={{ ...linkStyle, fontSize: '12px', wordBreak: 'break-word' }}
                                                    >
                                                        {item.url}
                                                    </a>
                                                )}
                                                {!item.url && (
                                                    <span style={{ fontSize: '12px', color: '#9a9a9a', fontStyle: 'italic' }}>
                                                        No URL (utility action)
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ProposedStructureSection;



